import React from 'react';
import { Link } from 'react-router-dom';

const AlohaFlix = () => {
  // 20+ Streaming platforms
  const platforms = [
    { name: 'Netflix', icon: 'N', color: 'bg-red-600' },
    { name: 'YouTube TV', icon: '▶', color: 'bg-red-500' },
    { name: 'YouTube Music', icon: '♫', color: 'bg-red-700' },
    { name: 'Hulu', icon: 'H', color: 'bg-green-500' },
    { name: 'Disney+', icon: 'D+', color: 'bg-blue-600' },
    { name: 'HBO Max', icon: 'HBO', color: 'bg-purple-600' },
    { name: 'Prime Video', icon: 'P', color: 'bg-cyan-500' },
    { name: 'Peacock', icon: '🦚', color: 'bg-blue-700' },
    { name: 'Paramount+', icon: '⛰️', color: 'bg-blue-800' },
    { name: 'Apple TV+', icon: '', color: 'bg-gray-800' },
    { name: 'ESPN+', icon: 'ESPN', color: 'bg-red-800' },
    { name: 'Roku', icon: 'ROKU', color: 'bg-purple-700' },
    { name: 'Xumo', icon: 'X', color: 'bg-orange-600' },
    { name: 'Pluto TV', icon: 'P', color: 'bg-orange-500' },
    { name: 'Tubi', icon: 'T', color: 'bg-pink-600' },
    { name: 'Crackle', icon: 'C', color: 'bg-yellow-600' },
    { name: 'Freevee', icon: 'FV', color: 'bg-cyan-600' },
    { name: 'Plex', icon: 'PLEX', color: 'bg-yellow-500' },
    { name: 'Sling TV', icon: 'S', color: 'bg-blue-900' },
    { name: 'Philo', icon: 'Φ', color: 'bg-sky-500' }
  ];

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Hero */}
      <div className="relative h-96 bg-gradient-to-r from-red-900 via-purple-900 to-blue-900">
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative z-10 flex items-center justify-center h-full text-center">
          <div>
            <h1 className="text-7xl font-bold mb-4">🎬 Aloha Flix</h1>
            <p className="text-2xl text-gray-300">Movies, TV Shows & Music - All in One Place</p>
            <p className="text-xl text-purple-300 mt-4">20+ Streaming Services Combined</p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Platforms */}
        <h2 className="text-4xl font-bold mb-8">Available Services</h2>
        <div className="grid grid-cols-4 md:grid-cols-5 gap-4 mb-16">
          {platforms.map((p, i) => (
            <div key={i} className={`${p.color} p-6 rounded-xl text-center hover:scale-105 transition-transform cursor-pointer`}>
              <div className="text-4xl font-bold mb-2">{p.icon}</div>
              <div className="text-sm font-bold">{p.name}</div>
            </div>
          ))}
        </div>

        {/* Content Grid */}
        <h3 className="text-3xl font-bold mb-6">Featured Content</h3>
        <div className="grid grid-cols-6 gap-4">
          {Array.from({length: 24}).map((_, i) => (
            <div key={i} className="bg-gray-900 rounded-lg overflow-hidden hover:scale-105 transition-transform cursor-pointer">
              <div className="aspect-[2/3] bg-gradient-to-br from-purple-900/50 to-pink-900/50 flex items-center justify-center text-4xl">🎬</div>
              <div className="p-2">
                <div className="text-xs font-bold line-clamp-2">Title {i+1}</div>
                <div className="text-xs text-gray-400">⭐ 4.{8-(i%5)}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AlohaFlix;